import {Box, Tooltip} from "@mui/material"
import FormattedToolTip from "../../../utils/FormattedToolTip"
import {AdminPanelSettings, Book, Edit} from "@mui/icons-material"

export default function WorkspacePermissionsIcons({workspacePermissions}) {
	return (
		<Box>
			{workspacePermissions.admin ?
				<Tooltip
					title={<FormattedToolTip
						title={"Is Admin"}
						description={"This user can Read, Edit, and manage user access to the Workspace"}
					/>}
					arrow
					placement={"bottom"}
				>
					<AdminPanelSettings/>
				</Tooltip>
				:
				<AdminPanelSettings color={"disabled"}/>
			}

			{ workspacePermissions.write ?
				<Tooltip
					title={<FormattedToolTip
						title={"Can Edit"}
						description={"This user can edit notes, articles, and searches in the Workspace"}
					/>}
					arrow
					placement={"bottom"}
				>
					<Edit />
				</Tooltip>
				:
				<Edit color={"disabled"}/>
			}
			{workspacePermissions.read ?
				<Tooltip
					title={<FormattedToolTip
						title={"Can Read"}
						description={"This user can read notes and articles in the Workspace"}
					/>}
					arrow
					placement={"bottom"}
				>
					<Book/>
				</Tooltip>
				:
				<Book color={"disabled"}/>
			}
		</Box>
	)
}